import React from 'react';
import UploadTester from '../components/debug/UploadTester';

export default function UploadTesterPage() {
  return <UploadTester />;
}